import React from 'react';
import s from './s.module.less';
import { Prospect, ProspectForm } from 'types/common';
import { getTimeStr } from 'utils/calendar';
import dayjs from 'utils/dayjs';
import CommonTable from 'components/CommonTable';
import { ColumnsType } from 'antd/es/table';
import useProspectForms from 'hooks/useProspectForms';
import axios from 'axios';
import { getScheduleToken, getUserToken } from 'utils/localstore';
import { baseURL } from 'api';
import { Button } from 'antd';

type Props = {
    prospect?: Prospect;
    hasPlan?: boolean;
    isGroupPractice?: boolean;
};

const Forms = (props: Props) => {
    const { prospect, hasPlan, isGroupPractice } = props;
    const [datas, loading] = useProspectForms(prospect?.id || 0);
    const [loadingDownload, setLoadingDownload] = React.useState(false);

    const handleDownload = async (item: ProspectForm) => {
        try {
            setLoadingDownload(true);
            const url = `${baseURL}schedule-server/prospect/form/download/${prospect?.id}/${item.consentType}`;
            const response = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    accept: 'application/json, text/plain, */*',
                    'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
                    'cache-control': 'no-cache',
                    origin: `${baseURL}`,
                    pragma: 'no-cache',
                    priority: 'u=1, i',
                    referer: `${baseURL}`,
                    // 'sec-ch-ua': '"Google Chrome";v="135", "Not-A.Brand";v="8", "Chromium";v="135"',
                    // 'sec-ch-ua-mobile': '?0',
                    // 'sec-ch-ua-platform': '"macOS"',
                    // 'sec-fetch-dest': 'empty',
                    // 'sec-fetch-mode': 'cors',
                    // 'sec-fetch-site': 'cross-site',
                    'schedule-token': getScheduleToken(),
                    ...(isGroupPractice ? { 'OVERRIDE-PROVIDER-ID': String(item.provider?.providerId) } : {}),
                    // 'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/135.0.0.0 Safari/537.36',
                    // 'Cookie': 'AWSALB=HH/eRDC1k7Dn6U2etvWV4a4ZkQCrxxBlk1kwXGDIoCiDu+gynKNqanH4yzp59vf8Gi3IXv45aZlQRcOmy9vP7YP5MvPl82D33rnWWonlXyKt7wASSlOUgKXp3LTD; AWSALBCORS=HH/eRDC1k7Dn6U2etvWV4a4ZkQCrxxBlk1kwXGDIoCiDu+gynKNqanH4yzp59vf8Gi3IXv45aZlQRcOmy9vP7YP5MvPl82D33rnWWonlXyKt7wASSlOUgKXp3LTD'
                },
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = downloadUrl;
            a.download = `${prospect?.id}_${item.consentType}.pdf`; // 可以根据需要调整

            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(a);
            // const res = await downloadProspectForms(prospect?.id!, item.consentType);
            // if (!res.error) {
            //     downloadFileWithBlob(res.data, prospect?.id + 'pdf');
            // }
            setLoadingDownload(false);
        } catch (e) {
            setLoadingDownload(false);
        }
    };

    return (
        <div className={s.wrap}>
            {datas.length > 0 ? (
                <div className={s.formList}>
                    {datas.map((item) => (
                        <div key={item.id} className={s.formItem}>
                            <div className={s.formItemName}>{item.consentType}</div>
                            <div className={s.formItemDate}>
                                Created: {item.createdAt ? getTimeStr(dayjs(item.createdAt), 'MM/DD/YYYY') : ''}
                            </div>
                            <div className={s.formItemDate}>
                                Modified: {item.updatedAt ? getTimeStr(dayjs(item.updatedAt), 'MM/DD/YYYY') : ''}
                            </div>
                            <div className={s.formItemDownload}>
                                <Button onClick={() => handleDownload(item)}>Download</Button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={s.empty}>No forms available.</div>
            )}
        </div>
    );
};

export default Forms;
